/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
 export const b2cPolicies = {
  names: {
      signUpSignIn: "B2C_1_gokuridev_loginOnly",
      editProfile: "B2C_1_gokuridev_edit_profile_v2",
      resetPassword: "B2C_1_gokuridev_password_reset"
  },
  authorities: {
      signUpSignIn: {
          authority: "https://gokuridev.b2clogin.com/tfp/gokuridev.onmicrosoft.com/B2C_1_gokuridev_loginOnly"
      },
      editProfile: {
          authority: "https://gokuridev.b2clogin.com/tfp/gokuridev.onmicrosoft.com/B2C_1_gokuridev_edit_profile_v2"
      },
      resetPassword: {
        authority: "https://gokuridev.b2clogin.com/tfp/gokuridev.onmicrosoft.com/B2C_1_gokuridev_password_reset"
      }
  },
  authorityDomain: "gokuridev.b2clogin.com"
}

// Bundled openid-configuration so MSAL skips the .well-known fetch on startup.
// Snapshot of:
// https://gokuridev.b2clogin.com/tfp/gokuridev.onmicrosoft.com/b2c_1_gokuridev_loginonly/v2.0/.well-known/openid-configuration
// Refresh with: curl -s "<url>" | jq -c
export const b2cAuthorityMetadata = JSON.stringify({
  issuer: "https://gokuridev.b2clogin.com/tfp/458787d6-3f2d-4425-b10d-d36f1cc54dc8/b2c_1_gokuridev_loginonly/v2.0/",
  authorization_endpoint: "https://gokuridev.b2clogin.com/gokuridev.onmicrosoft.com/b2c_1_gokuridev_loginonly/oauth2/v2.0/authorize",
  token_endpoint: "https://gokuridev.b2clogin.com/gokuridev.onmicrosoft.com/b2c_1_gokuridev_loginonly/oauth2/v2.0/token",
  end_session_endpoint: "https://gokuridev.b2clogin.com/gokuridev.onmicrosoft.com/b2c_1_gokuridev_loginonly/oauth2/v2.0/logout",
  jwks_uri: "https://gokuridev.b2clogin.com/gokuridev.onmicrosoft.com/b2c_1_gokuridev_loginonly/discovery/v2.0/keys",
  response_modes_supported: ["query", "fragment", "form_post"],
  response_types_supported: ["code", "code id_token", "code token", "code id_token token", "id_token", "id_token token", "token", "token id_token"],
  scopes_supported: ["openid"],
  subject_types_supported: ["pairwise"],
  id_token_signing_alg_values_supported: ["RS256"],
  token_endpoint_auth_methods_supported: ["client_secret_post", "client_secret_basic"],
  claims_supported: ["name", "idp", "oid", "sub", "emails", "idp_access_token", "tfp", "isForgotPassword", "iss", "iat", "exp", "aud", "acr", "nonce", "auth_time"]
});

/**
* Enter here the coordinates of your web API and scopes for access token request
* The current application coordinates were pre-registered in a B2C tenant.
*/
export const apiConfig: { scopes: string[]; uri: string; uriGeneral: string } = {
  scopes: ["openid", "offline_access", "https://gokuridev.onmicrosoft.com/0eca76ab-8bea-46a4-9bcf-d0e444683a09/b2c.user.read"],
  uri: 'https://gokuridevapis.azure-api.net/GOKURI-Dev/v3',
  uriGeneral: 'https://gokuridevapis.azure-api.net/GOKURI-Dev-General/v1'
};
